// All templates are defined in a 300x600 viewBox.
// Keychains are foldable: mirrored top/bottom halves connected by a narrow link.
// The center fold line is at y=300. Link runs from ~y=250 to y=350 (width 80, x=110..190).

export const TEMPLATES = {
  keychain: {
    circle: {
      name: 'Circle',
      icon: '⭕',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const cx = 150, r = 120;
        const lx = cx - lw / 2, rx = cx + lw / 2;
        const hw = Math.min(lw / 2, r - 1);
        const dy = Math.sqrt(r * r - hw * hw);
        return `M ${rx},${450 - dy} L ${rx},${150 + dy} A ${r},${r} 0 1 0 ${lx},${150 + dy} L ${lx},${450 - dy} A ${r},${r} 0 1 0 ${rx},${450 - dy} Z`;
      },
      get path() { return this.pathFn(); },
    },
    oval: {
      name: 'Oval',
      icon: '🥚',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const cx = 150, a = 100, b = 130;
        const lx = cx - lw / 2, rx = cx + lw / 2;
        const hw = Math.min(lw / 2, a - 1);
        const dy = b * Math.sqrt(1 - (hw * hw) / (a * a));
        return `M ${rx},${450 - dy} L ${rx},${150 + dy} A ${a},${b} 0 1 0 ${lx},${150 + dy} L ${lx},${450 - dy} A ${a},${b} 0 1 0 ${rx},${450 - dy} Z`;
      },
      get path() { return this.pathFn(); },
    },
    square: {
      name: 'Square',
      icon: '⬜',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},350 L ${rx},250 L 230,250 A 20,20 0 0 0 250,230 L 250,70 A 20,20 0 0 0 230,50 L 70,50 A 20,20 0 0 0 50,70 L 50,230 A 20,20 0 0 0 70,250 L ${lx},250 L ${lx},350 L 70,350 A 20,20 0 0 0 50,370 L 50,530 A 20,20 0 0 0 70,550 L 230,550 A 20,20 0 0 0 250,530 L 250,370 A 20,20 0 0 0 230,350 Z`;
      },
      get path() { return this.pathFn(); },
    },
    rounded: {
      name: 'Rounded',
      icon: '🔲',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},350 L ${rx},250 L 200,250 A 50,50 0 0 0 250,200 L 250,100 A 50,50 0 0 0 200,50 L 100,50 A 50,50 0 0 0 50,100 L 50,200 A 50,50 0 0 0 100,250 L ${lx},250 L ${lx},350 L 100,350 A 50,50 0 0 0 50,400 L 50,500 A 50,50 0 0 0 100,550 L 200,550 A 50,50 0 0 0 250,500 L 250,400 A 50,50 0 0 0 200,350 Z`;
      },
      get path() { return this.pathFn(); },
    },
    diamond: {
      name: 'Diamond',
      icon: '💠',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},390 L ${rx},210 L 250,150 L 150,50 L 50,150 L ${lx},210 L ${lx},390 L 50,450 L 150,550 L 250,450 Z`;
      },
      get path() { return this.pathFn(); },
    },
    shield: {
      name: 'Shield',
      icon: '🛡️',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},350 L ${rx},230 Q 250,220 250,100 L 250,50 L 50,50 L 50,100 Q 50,220 ${lx},230 L ${lx},350 Q 50,380 50,500 L 50,550 L 250,550 L 250,500 Q 250,380 ${rx},350 Z`;
      },
      get path() { return this.pathFn(); },
    },
    hexagon: {
      name: 'Hexagon',
      icon: '⬡',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},350 L ${rx},260 L 245,205 L 245,95 L 150,40 L 55,95 L 55,205 L ${lx},260 L ${lx},350 L 55,395 L 55,505 L 150,560 L 245,505 L 245,395 Z`;
      },
      get path() { return this.pathFn(); },
    },
    star: {
      name: 'Star',
      icon: '⭐',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},350 L ${rx - 1},347 L 221,443 L 150,389 L 79,443 L ${lx + 1},347 L ${lx},350 L ${lx + 1},347 L 36,299 L 126,299 L 150,230 L 174,299 L 264,299 L ${rx - 1},347 L ${rx},350 L ${rx},250 L ${rx - 1},253 L 264,299 L 174,299 L 150,230 L 150,230 Z`;
      },
      get path() { return this.pathFn(); },
    },
    teardrop: {
      name: 'Teardrop',
      icon: '💧',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},350 L ${rx},240 Q ${rx},180 150,50 Q ${lx},180 ${lx},240 L ${lx},350 Q ${lx},420 150,550 Q ${rx},420 ${rx},350 Z`;
      },
      get path() { return this.pathFn(); },
    },
    cross: {
      name: 'Cross',
      icon: '✚',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},350 L ${rx},250 L 250,250 L 250,190 L ${rx},190 L ${rx},50 L ${lx},50 L ${lx},190 L 50,190 L 50,250 L ${lx},250 L ${lx},350 L 50,350 L 50,410 L ${lx},410 L ${lx},550 L ${rx},550 L ${rx},410 L 250,410 L 250,350 Z`;
      },
      get path() { return this.pathFn(); },
    },
    dog_tag: {
      name: 'Dog Tag',
      icon: '🏷️',
      width: 300,
      height: 700,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        return `M ${rx},420 L ${rx},280 L 220,280 A 30,30 0 0 0 250,250 L 250,80 A 50,50 0 0 0 200,30 L 100,30 A 50,50 0 0 0 50,80 L 50,250 A 30,30 0 0 0 80,280 L ${lx},280 L ${lx},420 L 80,420 A 30,30 0 0 0 50,450 L 50,620 A 50,50 0 0 0 100,670 L 200,670 A 50,50 0 0 0 250,620 L 250,450 A 30,30 0 0 0 220,420 Z`;
      },
      get path() { return this.pathFn(); },
    },
    triangle: {
      name: 'Triangle',
      icon: '🔺',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        // Equilateral-ish triangle, top half point-up, bottom half point-down
        return `M ${rx},350 L ${rx},230 L 260,230 L 150,50 L 40,230 L ${lx},230 L ${lx},350 L 40,370 L 150,550 L 260,370 Z`;
      },
      get path() { return this.pathFn(); },
    },
    guitar_pick: {
      name: 'Guitar Pick',
      icon: '🎸',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        // Rounded top, pointed bottom → link → mirrored
        return `M ${rx},350 L ${rx},240 Q 260,160 260,110 A 110,110 0 0 0 40,110 Q 40,160 ${lx},240 L ${lx},350 Q 40,440 40,490 A 110,110 0 0 0 260,490 Q 260,440 ${rx},350 Z`;
      },
      get path() { return this.pathFn(); },
    },
    capsule: {
      name: 'Capsule',
      icon: '💊',
      width: 200,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const cx = 100, r = 100;
        const lx = cx - lw / 2, rx = cx + lw / 2;
        const hw = Math.min(lw / 2, r - 1);
        const dy = Math.sqrt(r * r - hw * hw);
        // Tall pill — semicircle top/bottom
        return `M ${rx},${450 - dy} L ${rx},${150 + dy} A ${r},${r} 0 1 0 ${lx},${150 + dy} L ${lx},${450 - dy} A ${r},${r} 0 1 0 ${rx},${450 - dy} Z`;
      },
      get path() { return this.pathFn(); },
    },
    house: {
      name: 'House',
      icon: '🏠',
      width: 300,
      height: 650,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        // Peaked roof top, flat bottom rectangle → link → mirrored
        return `M ${rx},375 L ${rx},250 L 250,250 L 250,150 L 150,50 L 50,150 L 50,250 L ${lx},250 L ${lx},375 L 50,375 L 50,500 L 50,550 L 150,650 L 250,550 L 250,500 L 250,375 Z`;
      },
      get path() { return this.pathFn(); },
    },
    octagon: {
      name: 'Octagon',
      icon: '🛑',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        // Regular octagon centered at (150,150) and (150,450), r≈120
        // Points at 22.5° intervals
        return `M ${rx},350 L ${rx},254 L 240,210 L 240,90 L 195,46 L 105,46 L 60,90 L 60,210 L ${lx},254 L ${lx},350 L 60,390 L 60,510 L 105,554 L 195,554 L 240,510 L 240,390 Z`;
      },
      get path() { return this.pathFn(); },
    },
    arrowhead: {
      name: 'Arrowhead',
      icon: '➤',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        // Arrow/chevron pointing up → link → mirrored pointing down
        return `M ${rx},350 L ${rx},200 L 250,200 L 150,50 L 50,200 L ${lx},200 L ${lx},350 L 50,400 L 150,550 L 250,400 Z`;
      },
      get path() { return this.pathFn(); },
    },
    novelty: {
      name: 'Novelty',
      icon: '🍆',
      width: 300,
      height: 600,
      defaultLinkWidth: 80,
      pathFn: (lw = 80) => {
        const lx = 150 - lw / 2, rx = 150 + lw / 2;
        // Bumps at top & bottom ends, mushroom cap at center fold.
        // When folded at y=300, bumps stack → base, cap → tip.
        return [
          // Right edge of mushroom cap at center fold
          `M 200,300`,
          // Cap curves upward (narrower than bumps)
          `Q 240,290 240,268`,
          `Q 240,248 200,243`,
          // Shaft narrows going up
          `L ${rx},238`,
          `L ${rx},195`,
          // Top-right bump
          `Q 265,185 268,135`,
          `Q 272,70 200,55`,
          // Valley between top bumps
          `Q 170,42 150,68`,
          `Q 130,42 100,55`,
          // Top-left bump
          `Q 28,70 32,135`,
          `Q 35,185 ${lx},195`,
          // Shaft going down to cap
          `L ${lx},238`,
          `L 100,243`,
          // Cap left side
          `Q 60,248 60,268`,
          `Q 60,290 100,300`,
          // --- Bottom mirror ---
          // Cap left side going down
          `Q 60,310 60,332`,
          `Q 60,352 100,357`,
          // Shaft going down
          `L ${lx},362`,
          `L ${lx},405`,
          // Bottom-left bump (mirrored)
          `Q 35,415 32,465`,
          `Q 28,530 100,545`,
          // Valley between bottom bumps
          `Q 130,558 150,532`,
          `Q 170,558 200,545`,
          // Bottom-right bump
          `Q 272,530 268,465`,
          `Q 265,415 ${rx},405`,
          // Shaft going up to cap
          `L ${rx},362`,
          `L 200,357`,
          // Cap right side bottom
          `Q 240,352 240,332`,
          `Q 240,310 200,300`,
          `Z`
        ].join(' ');
      },
      get path() { return this.pathFn(); },
    },
  },
  bookmark: {
    rectangle: {
      name: 'Rectangle',
      icon: '📖',
      width: 200,
      height: 600,
      path: `M 180,580 A 20,20 0 0 1 160,600 L 40,600 A 20,20 0 0 1 20,580 L 20,20 A 20,20 0 0 1 40,0 L 160,0 A 20,20 0 0 1 180,20 Z`,
      hole: `M 115,30 A 15,15 0 1 0 85,30 A 15,15 0 1 0 115,30 Z`,
    },
    banner: {
      name: 'Banner',
      icon: '🚩',
      width: 200,
      height: 600,
      path: `M 180,600 L 100,530 L 20,600 L 20,20 A 20,20 0 0 1 40,0 L 160,0 A 20,20 0 0 1 180,20 Z`,
      hole: `M 115,30 A 15,15 0 1 0 85,30 A 15,15 0 1 0 115,30 Z`,
    },
    pointed: {
      name: 'Pointed',
      icon: '📌',
      width: 200,
      height: 600,
      // Rectangle with a pointed bottom (like a traditional bookmark)
      path: `M 180,530 L 100,600 L 20,530 L 20,20 A 20,20 0 0 1 40,0 L 160,0 A 20,20 0 0 1 180,20 Z`,
      hole: `M 115,30 A 15,15 0 1 0 85,30 A 15,15 0 1 0 115,30 Z`,
    },
    scalloped: {
      name: 'Scalloped',
      icon: '🌊',
      width: 200,
      height: 600,
      // Rectangle with scalloped/wavy bottom edge
      path: `M 180,560 Q 160,580 140,560 Q 120,540 100,560 Q 80,580 60,560 Q 40,540 20,560 L 20,20 A 20,20 0 0 1 40,0 L 160,0 A 20,20 0 0 1 180,20 Z`,
      hole: `M 115,30 A 15,15 0 1 0 85,30 A 15,15 0 1 0 115,30 Z`,
    },
  },

  // Sticker / Patch shapes — standalone die-cut outlines for hat patches
  // 400×300 landscape viewBox, typical hat-patch proportions
  sticker: {
    none: {
      name: 'Freeform',
      icon: '🖼️',
      width: 400,
      height: 400,
      path: `M 0,0 L 400,0 L 400,400 L 0,400 Z`,
    },
    rectangle: {
      name: 'Rectangle',
      icon: '▬',
      width: 400,
      height: 250,
      path: `M 20,0 L 380,0 A 20,20 0 0 1 400,20 L 400,230 A 20,20 0 0 1 380,250 L 20,250 A 20,20 0 0 1 0,230 L 0,20 A 20,20 0 0 1 20,0 Z`,
    },
    rounded_rect: {
      name: 'Rounded',
      icon: '⬜',
      width: 400,
      height: 250,
      path: `M 40,0 L 360,0 A 40,40 0 0 1 400,40 L 400,210 A 40,40 0 0 1 360,250 L 40,250 A 40,40 0 0 1 0,210 L 0,40 A 40,40 0 0 1 40,0 Z`,
    },
    oval: {
      name: 'Oval',
      icon: '⬭',
      width: 400,
      height: 250,
      path: `M 200,0 A 200,125 0 1 1 200,250 A 200,125 0 1 1 200,0 Z`,
    },
    shield: {
      name: 'Shield',
      icon: '🛡️',
      width: 300,
      height: 350,
      path: `M 150,0 L 280,30 A 20,20 0 0 1 300,50 L 300,180 Q 300,310 150,350 Q 0,310 0,180 L 0,50 A 20,20 0 0 1 20,30 Z`,
    },
    pentagon: {
      name: 'Pentagon',
      icon: '⬠',
      width: 350,
      height: 330,
      path: `M 175,0 L 350,120 L 285,330 L 65,330 L 0,120 Z`,
    },
    hexagon: {
      name: 'Hexagon',
      icon: '⬡',
      width: 400,
      height: 346,
      path: `M 100,0 L 300,0 L 400,173 L 300,346 L 100,346 L 0,173 Z`,
    },
    chevron: {
      name: 'Chevron',
      icon: '⟩',
      width: 400,
      height: 250,
      path: `M 0,0 L 340,0 L 400,125 L 340,250 L 0,250 L 60,125 Z`,
    },
    badge: {
      name: 'Badge',
      icon: '🏅',
      width: 350,
      height: 380,
      path: `M 175,0 L 210,60 L 280,35 L 270,110 L 350,140 L 300,200 L 340,270 L 265,275 L 255,350 L 175,315 L 95,350 L 85,275 L 10,270 L 50,200 L 0,140 L 80,110 L 70,35 L 140,60 Z`,
    },
    tab: {
      name: 'Tab',
      icon: '🏷️',
      width: 400,
      height: 180,
      path: `M 20,0 L 380,0 A 20,20 0 0 1 400,20 L 400,160 A 20,20 0 0 1 380,180 L 220,180 L 200,160 L 180,180 L 20,180 A 20,20 0 0 1 0,160 L 0,20 A 20,20 0 0 1 20,0 Z`,
    },
    arched: {
      name: 'Arched',
      icon: '⌒',
      width: 400,
      height: 280,
      path: `M 0,280 L 0,120 A 200,120 0 0 1 400,120 L 400,280 Z`,
    },
  },

  // Dog Tag shapes — military and pet name tags
  dogtag: {
    military: {
      name: 'Military',
      icon: '🪖',
      width: 220,
      height: 400,
      // Classic military dog tag: rounded rectangle with notch
      path: `M 50,0 L 170,0 A 50,50 0 0 1 220,50 L 220,350 A 50,50 0 0 1 170,400 L 50,400 A 50,50 0 0 1 0,350 L 0,50 A 50,50 0 0 1 50,0 Z`,
      hole: `M 125,35 A 15,15 0 1 0 95,35 A 15,15 0 1 0 125,35 Z`,
    },
    military_wide: {
      name: 'Wide Military',
      icon: '🏷️',
      width: 300,
      height: 400,
      // Wider military tag — landscape orientation
      path: `M 50,0 L 250,0 A 50,50 0 0 1 300,50 L 300,350 A 50,50 0 0 1 250,400 L 50,400 A 50,50 0 0 1 0,350 L 0,50 A 50,50 0 0 1 50,0 Z`,
      hole: `M 165,35 A 15,15 0 1 0 135,35 A 15,15 0 1 0 165,35 Z`,
    },
    bone: {
      name: 'Bone',
      icon: '🦴',
      width: 400,
      height: 220,
      // Dog bone shape: rounded ends like knobs
      path: `M 60,40 A 40,40 0 0 1 100,0 A 40,40 0 0 1 140,40 L 260,40 A 40,40 0 0 1 300,0 A 40,40 0 0 1 340,40 A 40,40 0 0 1 400,80 A 40,40 0 0 1 360,120 L 360,140 A 40,40 0 0 1 400,180 A 40,40 0 0 1 340,220 A 40,40 0 0 1 300,180 A 40,40 0 0 1 260,180 L 140,180 A 40,40 0 0 1 100,220 A 40,40 0 0 1 60,180 A 40,40 0 0 1 0,140 A 40,40 0 0 1 40,100 L 40,80 A 40,40 0 0 1 0,40 A 40,40 0 0 1 60,40 Z`,
      hole: `M 215,100 A 15,15 0 1 0 185,100 A 15,15 0 1 0 215,100 Z`,
    },
    heart: {
      name: 'Heart',
      icon: '❤️',
      width: 300,
      height: 300,
      // Heart shape pet tag
      path: `M 150,280 Q 0,200 0,100 A 75,75 0 0 1 150,60 A 75,75 0 0 1 300,100 Q 300,200 150,280 Z`,
      hole: `M 165,40 A 12,12 0 1 0 135,40 A 12,12 0 1 0 165,40 Z`,
    },
    circle: {
      name: 'Circle',
      icon: '⭕',
      width: 300,
      height: 300,
      // Simple round pet tag
      path: `M 150,0 A 150,150 0 1 1 150,300 A 150,150 0 1 1 150,0 Z`,
      hole: `M 165,30 A 12,12 0 1 0 135,30 A 12,12 0 1 0 165,30 Z`,
    },
    paw: {
      name: 'Paw Print',
      icon: '🐾',
      width: 300,
      height: 340,
      // Paw print outline shape — main pad + four toes
      path: `M 150,340 Q 80,300 40,240 A 60,60 0 0 1 40,140 Q 60,100 100,100 Q 130,100 150,130 Q 170,100 200,100 Q 240,100 260,140 A 60,60 0 0 1 260,240 Q 220,300 150,340 Z M 70,80 A 30,30 0 1 1 70,20 A 30,30 0 1 1 70,80 Z M 140,60 A 28,28 0 1 1 140,4 A 28,28 0 1 1 140,60 Z M 160,60 A 28,28 0 1 1 160,4 A 28,28 0 1 1 160,60 Z M 230,80 A 30,30 0 1 1 230,20 A 30,30 0 1 1 230,80 Z`,
    },
    star: {
      name: 'Star',
      icon: '⭐',
      width: 300,
      height: 300,
      // 5-point star pet tag
      path: `M 150,10 L 185,100 L 280,110 L 210,175 L 230,270 L 150,225 L 70,270 L 90,175 L 20,110 L 115,100 Z`,
      hole: `M 165,50 A 10,10 0 1 0 145,50 A 10,10 0 1 0 165,50 Z`,
    },
    hydrant: {
      name: 'Hydrant',
      icon: '🚒',
      width: 240,
      height: 340,
      // Fire hydrant silhouette pet tag
      path: `M 80,0 L 160,0 L 160,40 L 180,40 L 180,80 L 200,80 L 200,120 L 240,120 L 240,180 L 200,180 L 200,220 L 180,220 L 180,280 L 200,280 L 200,340 L 40,340 L 40,280 L 60,280 L 60,220 L 40,220 L 40,180 L 0,180 L 0,120 L 40,120 L 40,80 L 60,80 L 60,40 L 80,40 Z`,
    },
    shield: {
      name: 'Shield',
      icon: '🛡️',
      width: 280,
      height: 340,
      // Shield shape pet tag
      path: `M 140,0 L 260,25 A 20,20 0 0 1 280,45 L 280,170 Q 280,290 140,340 Q 0,290 0,170 L 0,45 A 20,20 0 0 1 20,25 Z`,
      hole: `M 155,30 A 12,12 0 1 0 125,30 A 12,12 0 1 0 155,30 Z`,
    },
    collar_pill: {
      name: 'Collar Pill',
      icon: '💊',
      width: 360,
      height: 120,
      // Pill/stadium shape — riveted to collar, no hole
      path: `M 60,0 L 300,0 A 60,60 0 0 1 300,120 L 60,120 A 60,60 0 0 1 60,0 Z`,
    },
    collar_pill_sm: {
      name: 'Collar Pill Sm',
      icon: '💊',
      width: 280,
      height: 90,
      // Smaller pill for tighter collars
      path: `M 45,0 L 235,0 A 45,45 0 0 1 235,90 L 45,90 A 45,45 0 0 1 45,0 Z`,
    },
    collar_slide: {
      name: 'Collar Slide',
      icon: '📎',
      width: 320,
      height: 140,
      // Slide-on collar tag — pill with a slot for the collar strap
      path: `M 70,0 L 250,0 A 70,70 0 0 1 250,140 L 70,140 A 70,70 0 0 1 70,0 Z`,
      // Slot for collar to slide through
      hole: `M 90,55 L 230,55 A 15,15 0 0 1 230,85 L 90,85 A 15,15 0 0 1 90,55 Z`,
    },
  },

  // Business Card shapes — various sizes and corner styles
  // Standard US card ~3.5x2in → 350x200 viewBox
  businesscard: {
    standard: {
      name: 'Standard',
      icon: '📇',
      width: 350,
      height: 200,
      path: `M 0,0 L 350,0 L 350,200 L 0,200 Z`,
    },
    standard_rounded: {
      name: 'Std Rounded',
      icon: '📇',
      width: 350,
      height: 200,
      path: `M 12,0 L 338,0 A 12,12 0 0 1 350,12 L 350,188 A 12,12 0 0 1 338,200 L 12,200 A 12,12 0 0 1 0,188 L 0,12 A 12,12 0 0 1 12,0 Z`,
    },
    standard_pill: {
      name: 'Std Pill',
      icon: '💊',
      width: 350,
      height: 200,
      path: `M 100,0 L 250,0 A 100,100 0 0 1 250,200 L 100,200 A 100,100 0 0 1 100,0 Z`,
    },
    eu_standard: {
      name: 'EU Standard',
      icon: '🇪🇺',
      width: 335,
      height: 217,
      // 85mm x 55mm — standard European card
      path: `M 0,0 L 335,0 L 335,217 L 0,217 Z`,
    },
    eu_rounded: {
      name: 'EU Rounded',
      icon: '🇪🇺',
      width: 335,
      height: 217,
      path: `M 12,0 L 323,0 A 12,12 0 0 1 335,12 L 335,205 A 12,12 0 0 1 323,217 L 12,217 A 12,12 0 0 1 0,205 L 0,12 A 12,12 0 0 1 12,0 Z`,
    },
    square: {
      name: 'Square',
      icon: '⬜',
      width: 250,
      height: 250,
      path: `M 0,0 L 250,0 L 250,250 L 0,250 Z`,
    },
    square_rounded: {
      name: 'Square Rounded',
      icon: '🔲',
      width: 250,
      height: 250,
      path: `M 20,0 L 230,0 A 20,20 0 0 1 250,20 L 250,230 A 20,20 0 0 1 230,250 L 20,250 A 20,20 0 0 1 0,230 L 0,20 A 20,20 0 0 1 20,0 Z`,
    },
    slim: {
      name: 'Slim / Mini',
      icon: '📏',
      width: 350,
      height: 120,
      // Slim card — 3.5" x ~1.2"
      path: `M 8,0 L 342,0 A 8,8 0 0 1 350,8 L 350,112 A 8,8 0 0 1 342,120 L 8,120 A 8,8 0 0 1 0,112 L 0,8 A 8,8 0 0 1 8,0 Z`,
    },
    folded: {
      name: 'Folded',
      icon: '📁',
      width: 350,
      height: 400,
      // Folded card — 3.5x4" (folds to 3.5x2)
      path: `M 12,0 L 338,0 A 12,12 0 0 1 350,12 L 350,388 A 12,12 0 0 1 338,400 L 12,400 A 12,12 0 0 1 0,388 L 0,12 A 12,12 0 0 1 12,0 Z`,
    },
    premium: {
      name: 'Premium',
      icon: '✨',
      width: 370,
      height: 220,
      // Slightly oversized with generous rounded corners
      path: `M 24,0 L 346,0 A 24,24 0 0 1 370,24 L 370,196 A 24,24 0 0 1 346,220 L 24,220 A 24,24 0 0 1 0,196 L 0,24 A 24,24 0 0 1 24,0 Z`,
    },
  },
};

/**
 * Get the complete SVG path for a template, including any hole subpath.
 * For keychain templates with pathFn, linkWidth controls the bridge width.
 */
export function getTemplatePath(itemType, templateShape, linkWidth) {
  const t = TEMPLATES[itemType]?.[templateShape];
  if (!t) return null;
  const mainPath = t.pathFn ? t.pathFn(linkWidth ?? t.defaultLinkWidth ?? 80) : t.path;
  if (t.hole) {
    return mainPath + ' ' + t.hole;
  }
  return mainPath;
}

/**
 * Return template info for rendering at a stretched size.
 * The viewBox stays at native dimensions so paths are never clipped.
 * The SVG element should use preserveAspectRatio="none" and size to its
 * container (which is set to the scaled width/height) to achieve the stretch.
 */
export function getScaledTemplateInfo(itemType, templateShape, scaleX = 1, scaleY = 1, linkWidth) {
  const t = TEMPLATES[itemType]?.[templateShape];
  if (!t) return null;
  const mainPath = t.pathFn ? t.pathFn(linkWidth ?? t.defaultLinkWidth ?? 80) : t.path;
  return {
    width: Math.round(t.width * scaleX),
    height: Math.round(t.height * scaleY),
    // viewBox stays native — the SVG element stretches via its own width/height
    viewBox: `0 0 ${t.width} ${t.height}`,
    path: t.hole ? mainPath + ' ' + t.hole : mainPath,
    nativeWidth: t.width,
    nativeHeight: t.height,
  };
}
